import CoursesComponent from "@/components/courses/Courses";
import { useIsMobile } from "@/hooks/use-mobile";

const Courses = () => {
  const isMobile = useIsMobile();
  
  return (
    <main className={`relative pt-20 lg:pt-[88px] ${!isMobile ? 'bg-gradient-to-b from-black via-[#0a0a0f] to-black' : ''}`}>
      {/* Courses Section */}
      <CoursesComponent />
    </main>
  );
};

export default Courses;
